import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import createPersistedState from "use-persisted-state";
import { useTranslation } from "react-i18next";

//TODO: To refactor
const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");

const isIC4EnabledClinic = (clinicId) => {
  return clinicId === "CC000001" || clinicId === "CC000002";
};

const TermsCondtions = ({ onSubmitHandler, state }) => {
  const [profile, setProfile] = useState(state);
  const history = useHistory();
  const URL = "/api/v1/users/register";
  const [token, _] = useTokenState();
  const [pid, setPID] = usePIDState();
  const [username, setUsername] = useState();
  const { t, i18n } = useTranslation();
  const [tcAccepted, setTCAccepted] = useState(false);
  const [isCreatingProfile, setIsCreatingProfile] = useState(false);
  const [hasError, setError] = useState({
    status: false,
    msg: "",
  });

  useEffect(() => {
    setUsername(pid);
  }, [pid]);

  useEffect(() => {
    //createProfile();
  }, [username, token]);

  const createProfile = () => {
    console.log("Creating profile");
    setError({ status: false, msg: "" });

    let requestBody = {
      tid: token,
      language: i18n.language,
      firstName: profile["NAME"]["first"],
      middleName: profile["NAME"]["middle"],
      lastName: profile["NAME"]["last"],
      // doctorId: profile["TREATING-DOC"]["value"],
      clinicId:
        profile["EXISTING-PATIENT"] &&
        profile["EXISTING-PATIENT"]["value"] == "yes" &&
        isIC4EnabledClinic(profile["TREATING-LOC"]["value"])
          ? profile["TREATING-LOC"]["value"]
          : profile["PREF-TREATING-LOC"]["value"],
      oldPatientId: profile["PID"] || "",
      oldClinic:
        profile["EXISTING-PATIENT"] &&
        profile["EXISTING-PATIENT"]["value"] == "yes"
          ? !isIC4EnabledClinic(profile["TREATING-LOC"]["value"])
            ? profile["TREATING-LOC"]["text"]
            : null
          : null,
      dob: profile["DOB"]["date"],
      gender: profile["GENDER"],
      email: profile["EMAIL"]["email"],
      zipCode: profile["RESIDENCE"]["pin"],
      address: profile["RESIDENCE"]["text"],
    };

    if (profile["DOB"]["age"] < 18) {
      requestBody["minorConsent"] = profile["DOB"]["minorConsent"];
    }

    fetch(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((responseData) => {
        setIsCreatingProfile(false);
        if (responseData["status"]["success"]) {
          console.log(responseData);
          console.log(pid);
          setUsername(responseData["patientId"]);
          setPID(responseData["patientId"]);
          onSubmitHandler(true);
        } else {
          setError({ status: true, msg: responseData["status"]["message"] });
          //onSubmitHandler(false);
        }
      })
      .catch((err) => {
        setError({ status: true, msg: err });
        //onSubmitHandler(false)
      });
  };

  const clickSubmit = () => {
    setIsCreatingProfile(true);
    createProfile();
  };

  const handleChange = (e) => {
    setTCAccepted(e.target.checked);
  };
  return (
    <>
      <div className="body_content">
        <div className="inner_body mt-4">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input checkboxTerms "
              id="check1"
              name="option1"
              value={tcAccepted}
              onChange={handleChange}
            />
            <label className="form-check-label">
              <h4>
                {t("login.CONDITION.description1")}
                <Link to="/terms" className="termCondtion">
                  {t("login.CONDITION.description2")}
                </Link>
                {t("login.CONDITION.description3")}
                <Link to="/privacy" className="termCondtion">
                  {t("login.CONDITION.description4")}
                </Link>
                {t("login.CONDITION.description5")}
              </h4>
            </label>
          </div>

          <div className="d-flex justify-content-center loader">
            {isCreatingProfile ? <div id="loader"></div> : <></>}

            {hasError.status ? (
              <div>
                <span className="txt_help " style={{ color: "red" }}>
                  {hasError.msg}
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>

          <div className="btn_block d-flex justify-content-center bottom_button">
            {!hasError.status && (
              <button
                disabled={!tcAccepted}
                className="btn btn_primary"
                onClick={() => clickSubmit()}
              >
                {t("login.CONDITION.button")}
              </button>
            )}
            {hasError.status && (
              <button
                className="btn btn_primary"
                onClick={() => history.push("/register")}
              >
                {t("onboard.COMMON.goBack")}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsCondtions;
